import { render, staticRenderFns } from "./SaplingListPreview.vue?vue&type=template&id=616f8a40&scoped=true"
import script from "./SaplingListPreview.vue?vue&type=script&lang=ts"
export * from "./SaplingListPreview.vue?vue&type=script&lang=ts"
import style0 from "./SaplingListPreview.vue?vue&type=style&index=0&id=616f8a40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616f8a40",
  null
  
)

export default component.exports